import {
  applyProductSurface,
  type ResolveTarget,
  type SurfaceCopyPayload,
} from './applyProductSurface'

/**
 * Resolve a surface's promo copy for rendering: layer the `productSurface`
 * overrides over the default copy for the given `surface` + release state, or
 * null when there is no promo.
 *
 * `target.surface` is where the copy renders (`cert` / `subscription`);
 * `comingSoon` is the release state (a coming-soon product also gets that
 * surface's `comingSoon` overrides). Both axes are honored and layered — neither
 * replaces the other. Whether to show a promo at all (enrollment state, the
 * best-coupon winner gate) stays with the caller.
 */
export const resolvePromoCopy = <T extends SurfaceCopyPayload>(
  promoVariables: T | null | undefined,
  target: ResolveTarget,
): Omit<T, 'productSurface'> | null =>
  promoVariables ? applyProductSurface(promoVariables, target) : null
